import { SystemStyleObject } from '@chakra-ui/react';
import {
  ColorMode,
  getTypographyToken,
} from '@allergan-data-labs/alle-elements-core';

export const getActionListItemStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    cursor: 'pointer',
    padding: '4',
    minHeight: '32',
    color: `${colorMode}.Text/Neutral/Default`,
    background: `${colorMode}.Container/Neutral/Transparent interactive/Enable`,
    ...getTypographyToken('Body/Small/Regular'),
    borderRadius: 'Small',
    border: 'none',
    _hover: {
      background: `${colorMode}.Container/Neutral/Transparent interactive/Hover`,
    },
    _active: {
      background: `${colorMode}.Container/Neutral/Transparent interactive/Pressed`,
    },
    _focusVisible: {
      background: `${colorMode}.Container/Neutral/Transparent interactive/Hover`,
      outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
      outlineStyle: 'solid',
      outlineWidth: '4px',
      outlineOffset: '-2px',
    },
    _disabled: {
      cursor: 'not-allowed',
      color: `${colorMode}.Text/Neutral/Disabled/Default`,
      _hover: {
        background: `${colorMode}.Container/Neutral/Transparent interactive/Enable`,
      },
      _active: {
        background: `${colorMode}.Container/Neutral/Transparent interactive/Enable`,
      },
      '.action-list-item__description': {
        color: `${colorMode}.Text/Neutral/Disabled/Default`,
      },
    },
    '.chakra-menu__icon-wrapper': {
      color: 'inherit',
      alignItems: 'center',
      justifyContent: 'center',
      marginInlineEnd: '4',
      flex: '0 1 auto',
    },
    '.chakra-menu__command': {
      color: `inherit`,
      ...getTypographyToken('Caption/Small/Regular'),
      alignSelf: 'flex-start',
      paddingTop: '4',
      paddingRight: '4',
    },
  };
};

export const getActionListItemTextStyle = (
  colorMode: ColorMode,
  isActive: boolean
): SystemStyleObject => {
  return {
    color: isActive ? `${colorMode}.Text/Brand/Default` : 'inherit',
    paddingLeft: '4',
    paddingRight: '4',
    w: '100%',
  };
};

export const getActionListItemDescriptionStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    color: `${colorMode}.Text/Neutral/Support`,
    ...getTypographyToken('Caption/Medium/Regular'),
    padding: 0,
    flex: '0 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  };
};

export const getActionListItemRightContentStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    color: `${colorMode}.Text/Neutral/Support`,
    ...getTypographyToken('Caption/Medium/Regular'),
    padding: 0,
  };
};

export const getActionListSubItemDescriptionStyles = (): SystemStyleObject => {
  return {
    p: 0,
  };
};

export const getActionListHeaderStyles = (): SystemStyleObject => {
  return {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
  };
};

export const getActionListChildrenContainerStyles = (): SystemStyleObject => {
  return {
    alignItems: 'center',
    gap: 1,
  };
};

export const getActionListChildrenWrapperStyles = (): SystemStyleObject => {
  return {
    flexDir: 'column',
    flex: 1,
  };
};
